exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.reset-password-card\n{\n  max-width: 400px;\n  margin: auto;\n  margin-top: 100px;\n  text-align: center;\n  min-height: 400px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/reset-password/reset-password.style.css
// module id = 910
// module chunks = 3